import React, { useState} from 'react';
import Reaptcha from 'reaptcha';
import './index.css';

function Form() {
    const [btnText, setBtn] = useState('Submit');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [recaptchaResponse, setResponse] = useState('');
    const [isValid, setValid] = useState(false);

    const onVerify = res => {
        setResponse(res);
        setValid(true);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const body = {
            sender: 'foamsolutions',
            gResponse: recaptchaResponse,
            name: name,
            email: email,
            phone: phone,
            message: message,
            emails: ['management@lovast.com', 'ps@fs131.com']
        };
        const res = fetch('https://lovast.com/api/v1/comms/email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify(body),
        });
        setBtn('Form submitted!');
        e.target.reset();
    }

    return(
        <form name="contact" className="form-container" method="POST" onSubmit={handleSubmit}>
            <div className="flex">
                <input className="form-input" required type="text" id="fname" name="fname" placeholder="Full Name*" onChange={e => setName(e.target.value)} />
            </div>
            <div className="flex">
                <input className="form-input" required type="email" id="email" name="email" placeholder="Email*" onChange={e => setEmail(e.target.value)} />
            </div>
            <div className="flex">
                <input className="form-input" required type="phone" id="phone" name="phone" placeholder="Phone Number*" onChange={e => setPhone(e.target.value)} />
            </div>
            <div className="flex">
                <textarea style={{resize: 'none'}} className="form-input" id="messagebox" rows="4" placeholder="Message here..." onChange={e => setMessage(e.target.value)}/>
            </div>
            <Reaptcha sitekey="6Leil6gUAAAAAFjtE3clAglFBnIraxn1O9mzDFCT" onVerify={onVerify}/>
            <button type='submit' className="submit-button" 
            disabled={(name === '' || email === '' || phone === '' || btnText === '...sending' || btnText === 'Message Sent') ? true:false}>
                {btnText}</button>
        </form>
    );
}

export default Form;
